'use client';

import React, { useState, useCallback } from 'react';
import { getSearchSuggestion } from 'app/apis/search';
import clsx from 'clsx';
import { FormControlCombobox } from '@shared/ui';

interface InputProps {
    name: string;
    className?: string;
    defaultValue?: string;
    placeholder?: string;
    onChange: (value: string) => void;
    onEnter?: (value: string) => void;
    disabled?: boolean;
}

export const SearchCombo = (props: InputProps) => {
    const { name, className, placeholder, defaultValue = '', onChange, onEnter } = props;

    const [searchSuggestion, setSearchSuggestion] = useState<SearchSuggestion[]>([]);

    const handleOnSearch = useCallback(
        async (value: string) => {
            onChange(value);

            try {
                const res = await getSearchSuggestion({
                    query: value,
                });

                if (res?.data) {
                    setSearchSuggestion(res.data);
                }
            } catch (error) {
                console.error(error);
            }
        },
        [setSearchSuggestion, onChange]
    );

    return (
        <div className={clsx('search-bar-box', className)}>
            <FormControlCombobox
                name={name}
                defaultValue={defaultValue}
                inputProps={{
                    className: 'search-bar-input',
                    height: 'auto',
                }}
                searchItems={searchSuggestion.map((suggestion) => suggestion.text)}
                placeholder={placeholder}
                onChange={handleOnSearch}
                onEnter={onEnter}
            />
        </div>
    );
};
